import { createReducer } from "typesafe-actions";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import DistanceTravelledCardConfiguration from "@app/types/dashboard/cards/distanceTravelled/DistanceTravelledCardConfiguration";
import Scope from "@app/types/dashboard/Scope";
import { DEFAULT_PAGE_SIZE } from "@app/util/consts";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import {
  applyDistanceTravelledDrillDownListViewSettings,
  DistanceTravelledCardActions,
  fetchDistanceTravelledCardDrillDownData,
  hideDistanceTravelledDrillDown,
  showDistanceTravelledDrillDown,
} from "./actions";

export interface DistanceTravelledCardState {
  configuration?: DistanceTravelledCardConfiguration; // also works as a "visible" trigger, visible if set
  drillDownCustomDateRange?: DateRange;
  // kept so the distances branch can rebuild its user filter when a page is fetched
  drillDownScope?: Scope;
  loading?: boolean;
  totalFilteredRecords: number;
  totalRecords: number;
  viewState: DrillDownViewState;
}

export const distanceTravelledInitialState: DistanceTravelledCardState = {
  totalFilteredRecords: 0,
  totalRecords: 0,
  viewState: {
    columns: [],
    filter: createEmptyFilterModel(),
    range: { endRow: DEFAULT_PAGE_SIZE, startRow: 0 },
    sort: [],
  },
};

const distanceTravelledState = createReducer<
  DistanceTravelledCardState,
  DistanceTravelledCardActions
>(distanceTravelledInitialState)
  .handleAction(showDistanceTravelledDrillDown.request, (state, { payload }) => ({
    ...state,
    configuration: payload.configuration,
    drillDownCustomDateRange: payload.customDateRange,
    drillDownScope: payload.scope,
  }))
  .handleAction(showDistanceTravelledDrillDown.success, (state, { payload }) => ({
    ...state,
    viewState: payload.viewState,
  }))
  .handleAction(hideDistanceTravelledDrillDown, (state) => ({
    ...state,
    configuration: undefined,
    drillDownCustomDateRange: undefined,
    drillDownScope: undefined,
  }))
  .handleAction(fetchDistanceTravelledCardDrillDownData.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchDistanceTravelledCardDrillDownData.success, (state, { payload }) => ({
    ...state,
    loading: false,
    totalFilteredRecords: payload.totalFilteredRecords,
    totalRecords: payload.totalRecords,
  }))
  .handleAction(fetchDistanceTravelledCardDrillDownData.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(applyDistanceTravelledDrillDownListViewSettings, (state, { payload }) => ({
    ...state,
    viewState: {
      ...state.viewState,
      columns: payload.columns ?? state.viewState.columns,
      filter: payload.filter ?? state.viewState.filter,
      range: payload.range ?? state.viewState.range,
      sort: payload.sort ?? state.viewState.sort,
    },
  }));

export default distanceTravelledState;
